import { render, staticRenderFns } from "./ProjectCopyDialog.vue?vue&type=template&id=43094cd5&scoped=true"
import script from "./ProjectCopyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCopyDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43094cd5",
  null
  
)

export default component.exports